// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tcList":"AgentTermsConditions__tcList--1ihK6"};